import '../../../../../styles.scss';
import React, { useEffect, useState } from 'react';
import { ASSET_PATH } from '../../../../consts/env.consts';
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { setFirstClick } from '../../../../helpers/firstClick';
import useGetBlogPostsSSR from '../../hooks/useGetBlogPosts';
import useMobileScreen from '../../hooks/useMobileScreen';
import BlogAuthorSSR from '../../../../pages/blog/author';
import { loadFirebaseAfterPageLoad } from '../../../../helpers/load-firebase';

// eslint-disable-next-line no-undef
__webpack_public_path__ = ASSET_PATH;

const client = new ApolloClient({
    link: new HttpLink({ uri: '/graphql' }),
    cache: new InMemoryCache(),
});

const BlogAuthor = (props) => {
    const isMobileSSR = useMobileScreen();

    useEffect(() => {
        setFirstClick();
        loadFirebaseAfterPageLoad();
    }, []);

    return (
        <ApolloProvider client={client}>
            <BlogAuthorSSR {...{ ...props, useGetBlogPostsSSR, isMobileSSR, useEffectSSR: useEffect, useStateSSR: useState }} />
        </ApolloProvider>
    );
};

export default BlogAuthor;
